export const CSS_CLASSES = {
	HIDDEN: 'root--hidden',
	ROOT_CONTAINER: 'root__container',
	TITLE_CONTAINER: 'title__container',
	TITLE: 'title',
};